var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 15,
    viewBox: "0 0 27 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.28319 6.79289C-0.107334 7.18342 -0.107334 7.81658 0.28319 8.20711L6.64715 14.5711C7.03768 14.9616 7.67084 14.9616 8.06137 14.5711C8.45189 14.1805 8.45189 13.5474 8.06137 13.1569L2.40451 7.5L8.06137 1.84315C8.45189 1.45262 8.45189 0.819457 8.06137 0.428932C7.67084 0.0384078 7.03768 0.0384078 6.64715 0.428932L0.28319 6.79289ZM27.0095 6.5L0.990297 6.5V8.5L27.0095 8.5V6.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.caa7ff6b335ded1e3bd0497d1ab3566a.svg";
export { ForwardRef as ReactComponent };